import { useState, useEffect, useRef } from "react";
import { apiFetch } from "./utils/api";

const FontLink = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700;800&family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;1,9..40,400&family=JetBrains+Mono:wght@400;500;600&display=swap');

    *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
    html, body { min-height: 100vh; }

    @keyframes fadeUp   { from { opacity:0; transform:translateY(20px); } to { opacity:1; transform:translateY(0); } }
    @keyframes fadeIn   { from { opacity:0; } to { opacity:1; } }
    @keyframes slideUp  { from { opacity:0; transform:translateY(40px); } to { opacity:1; transform:translateY(0); } }
    @keyframes shake    { 0%,100%{transform:translateX(0)} 20%,60%{transform:translateX(-6px)} 40%,80%{transform:translateX(6px)} }
    @keyframes pulse    { 0%,100%{opacity:1;transform:scale(1)} 50%{opacity:.6;transform:scale(.95)} }
    @keyframes spin     { to { transform: rotate(360deg); } }
    @keyframes pop      { 0%{transform:scale(.8);opacity:0} 70%{transform:scale(1.08)} 100%{transform:scale(1);opacity:1} }
    @keyframes countdown { from{stroke-dashoffset:0} to{stroke-dashoffset:138} }
    @keyframes gradMove { 0%{background-position:0% 50%} 50%{background-position:100% 50%} 100%{background-position:0% 50%} }
    @keyframes checkDraw { from{stroke-dashoffset:50} to{stroke-dashoffset:0} }

    .fade-up  { animation: fadeUp  .55s cubic-bezier(.22,1,.36,1) both; }
    .slide-up { animation: slideUp .6s  cubic-bezier(.22,1,.36,1) both; }
    .fade-in  { animation: fadeIn  .4s  ease both; }
    .pop      { animation: pop     .4s  cubic-bezier(.22,1,.36,1) both; }

    ::-webkit-scrollbar { width: 4px; }
    ::-webkit-scrollbar-thumb { background: #E8520A44; border-radius: 10px; }

    .otp-input {
      width: 52px; height: 58px; text-align: center;
      font-family: 'JetBrains Mono', monospace; font-size: 24px; font-weight: 600;
      border: 2px solid #E2E8F0; border-radius: 12px;
      color: #0D1B2A; background: #fff; outline: none;
      transition: border-color .2s, box-shadow .2s, transform .15s;
      caret-color: #E8520A;
    }
    .otp-input:focus {
      border-color: #E8520A;
      box-shadow: 0 0 0 4px rgba(232,82,10,.12);
      transform: scale(1.05);
    }
    .otp-input.filled { border-color: #10B981; background: #F0FDF4; }
    .otp-input.error  { border-color: #EF4444; animation: shake .4s ease; }

    .rating-btn {
      flex: 1; padding: 10px 8px; border-radius: 10px;
      border: 2px solid #E2E8F0; background: #fff;
      font-family: 'DM Sans', sans-serif; font-size: 11px; font-weight: 500;
      color: #94A3B8; cursor: pointer; transition: all .18s;
      display: flex; flex-direction: column; align-items: center; gap: 4px;
      position: relative; text-align: center; line-height: 1.2;
      min-width: 0; word-break: break-word;
    }
    .rating-btn:hover { border-color: #CBD5E1; color: #475569; transform: translateY(-1px); }
    .rating-btn.selected-1 { border-color: #EF4444; background: #FEF2F2; color: #DC2626; font-weight: 700; }
    .rating-btn.selected-2 { border-color: #F59E0B; background: #FFFBEB; color: #D97706; font-weight: 700; }
    .rating-btn.selected-3 { border-color: #3B82F6; background: #EFF6FF; color: #2563EB; font-weight: 700; }
    .rating-btn.selected-4 { border-color: #10B981; background: #F0FDF4; color: #059669; font-weight: 700; }

    .form-input {
      width: 100%; padding: 11px 14px;
      font-family: 'DM Sans', sans-serif; font-size: 14px;
      border: 2px solid #E2E8F0; border-radius: 10px;
      color: #0D1B2A; background: #fff; outline: none;
      transition: border-color .2s, box-shadow .2s;
    }
    .form-input:focus {
      border-color: #E8520A;
      box-shadow: 0 0 0 4px rgba(232,82,10,.1);
    }

    .step-btn {
      padding: 13px 28px; border-radius: 12px; border: none;
      font-family: 'DM Sans', sans-serif; font-size: 15px; font-weight: 600;
      cursor: pointer; transition: all .2s;
      display: inline-flex; align-items: center; gap: 8px;
    }
    .step-btn-primary {
      background: linear-gradient(135deg, #E8520A, #FF7434);
      color: #fff; box-shadow: 0 4px 20px rgba(232,82,10,.3);
    }
    .step-btn-primary:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 28px rgba(232,82,10,.4);
    }
    .step-btn-primary:active { transform: translateY(0); }
    .step-btn-primary:disabled {
      background: #E2E8F0; color: #94A3B8;
      box-shadow: none; cursor: not-allowed; transform: none;
    }
    .step-btn-secondary {
      background: #fff; color: #475569;
      border: 2px solid #E2E8F0 !important;
    }
    .step-btn-secondary:hover { border-color: #CBD5E1 !important; background: #F8FAFC; }

    .progress-track { height: 4px; background: #F1F5F9; border-radius: 100px; overflow: hidden; }
    .progress-fill  {
      height: 100%; border-radius: 100px;
      background: linear-gradient(90deg, #E8520A, #FF8C5A);
      transition: width .6s cubic-bezier(.22,1,.36,1);
    }

    .section-card {
      background: #fff; border-radius: 16px;
      box-shadow: 0 1px 3px rgba(0,0,0,.06), 0 4px 16px rgba(0,0,0,.04);
      margin-bottom: 16px; overflow: hidden;
    }

    .copy-checkbox {
      display: flex; align-items: flex-start; gap: 12px;
      padding: 16px 18px; background: #FFF8F5;
      border: 2px solid #FED7C3; border-radius: 12px; cursor: pointer;
    }
    .copy-checkbox input[type=checkbox] {
      width: 18px; height: 18px; margin-top: 1px; cursor: pointer;
      accent-color: #E8520A; flex-shrink: 0;
    }
  `}</style>
);

/* ─── Constants ─────────────────────────────────────────────────────── */
const CRITERIA = [
  { id: 1, label: "Works to Full Potential", section: "Performance" },
  { id: 2, label: "Quality of Work", section: "Performance" },
  { id: 3, label: "Work Consistency", section: "Performance" },
  { id: 4, label: "Communication", section: "Interpersonal" },
  { id: 5, label: "Independent Work", section: "Performance" },
  { id: 6, label: "Takes Initiative", section: "Performance" },
  { id: 7, label: "Group Work", section: "Interpersonal" },
  { id: 8, label: "Productivity", section: "Performance" },
  { id: 9, label: "Creativity", section: "Performance" },
  { id: 10, label: "Honesty", section: "Values" },
  { id: 11, label: "Integrity", section: "Values" },
  { id: 12, label: "Coworker Relations", section: "Interpersonal" },
  { id: 13, label: "Client Relations", section: "Interpersonal" },
  { id: 14, label: "Technical Skills", section: "Performance" },
  { id: 15, label: "Dependability", section: "Values" },
  { id: 16, label: "Punctuality", section: "Conduct" },
  { id: 17, label: "Attendance", section: "Conduct" },
];

const RATINGS = [
  { value: 1, label: "Unsatisfactory", short: "Unsat.", emoji: "😟", color: "1" },
  { value: 2, label: "Satisfactory", short: "Sat.", emoji: "🙂", color: "2" },
  { value: 3, label: "Good", short: "Good", emoji: "😊", color: "3" },
  { value: 4, label: "Excellent", short: "Excel.", emoji: "🌟", color: "4" },
];

// SECTIONS is now derived dynamically from criteria inside FormScreen — no longer a top-level constant

/* ─── Background ─────────────────────────────────────────────────────── */
const Bg = () => (
  <div style={{
    position: "fixed", inset: 0, zIndex: 0,
    background: "linear-gradient(135deg, #0D1B2A 0%, #1A3A5C 40%, #0D2E1E 100%)",
    backgroundSize: "400% 400%", animation: "gradMove 12s ease infinite",
    overflow: "hidden",
  }}>
    {/* Decorative circles */}
    {[
      { w: 500, h: 500, t: -100, l: -150, op: .06 },
      { w: 400, h: 400, t: "auto", b: -80, r: -100, op: .05 },
      { w: 300, h: 300, t: 160, r: 80, op: .04 },
    ].map((c, i) => (
      <div key={i} style={{
        position: "absolute", width: c.w, height: c.h,
        top: c.t, left: c.l, bottom: c.b, right: c.r,
        borderRadius: "50%",
        background: `radial-gradient(circle, rgba(232,82,10,${c.op * 3}) 0%, transparent 70%)`,
        opacity: c.op * 10,
      }} />
    ))}
    <div style={{
      position: "absolute", inset: 0,
      backgroundImage: `radial-gradient(circle, rgba(255,255,255,.015) 1px, transparent 1px)`,
      backgroundSize: "28px 28px",
    }} />
  </div>
);


/* ─── Screen: Email Entry ────────────────────────────────────────────── */
const EmailScreen = ({ onNext, preview, previewLoading, reviewId }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handle = async () => {
    if (!email.includes("@")) { setError("Please enter a valid email address."); return; }
    setError(""); setLoading(true);
    try {
      const res = await apiFetch("/api/auth/stakeholder/request-otp", {
        method: "POST",
        body: JSON.stringify({ email, reviewId }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.message || "Failed to send OTP."); return; }
      if (!data.otpSent) {
        setError(data.message || "No pending reviews found. Please check your email or contact admin@dolluzcorp.com.");
        return;
      }
      onNext(email, data._devOtp || null, data.otpEmail || null);
    } catch (e) {
      setError("Network error. Please try again.");
    } finally { setLoading(false); }
  };

  const domainHint = preview && preview.primary_domain
    ? `Your domain will be validated against ${preview.client_name}'s authorised domains.`
    : "Your domain will be validated against your organisation's authorised domains.";

  const emailPlaceholder = preview && preview.primary_domain
    ? `yourname@${preview.primary_domain}`
    : "yourname@company.com";

  return (
    <div className="slide-up" style={{ width: "100%", maxWidth: 440 }}>
      <div style={{ background: "#fff", borderRadius: 24, padding: "40px 36px", boxShadow: "0 32px 80px rgba(0,0,0,.3)" }}>
        {/* Logo */}
        <div style={{ marginBottom: 32, textAlign: "center" }}>
          <div style={{ fontFamily: "'Sora',sans-serif", fontWeight: 800, fontSize: 26, color: "#0D1B2A", letterSpacing: -1 }}>
            Dolluz Corp<span style={{ color: "#E8520A" }}>.</span>
          </div>
          <div style={{ fontSize: 11, color: "#94A3B8", fontWeight: 600, letterSpacing: 2, textTransform: "uppercase", marginTop: 3 }}>
            Employee Performance Review
          </div>
        </div>

        {/* Employee info banner — dynamic */}
        {previewLoading ? (
          <div style={{ background: "#F8FAFC", border: "1.5px solid #E2E8F0", borderRadius: 14, padding: "18px 16px", marginBottom: 28, display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{ width: 16, height: 16, border: "2px solid #CBD5E1", borderTopColor: "#64748B", borderRadius: "50%", animation: "spin .8s linear infinite", flexShrink: 0 }} />
            <span style={{ fontSize: 13, color: "#94A3B8" }}>Loading review details…</span>
          </div>
        ) : preview ? (
          <div style={{ background: "linear-gradient(135deg,#F0F9FF,#EFF6FF)", border: "1.5px solid #BFDBFE", borderRadius: 14, padding: "14px 16px", marginBottom: 28 }}>
            <div style={{ fontSize: 11, color: "#3B82F6", fontWeight: 700, textTransform: "uppercase", letterSpacing: 1, marginBottom: 6 }}>You are reviewing</div>
            <div style={{ fontFamily: "'Sora',sans-serif", fontWeight: 700, fontSize: 17, color: "#0D1B2A" }}>{preview.employee_name}</div>
            <div style={{ fontSize: 12, color: "#64748B", marginTop: 3 }}>
              {[preview.designation, preview.client_name, preview.cycle_name].filter(Boolean).join(" · ")}
            </div>
            <div style={{ display: "flex", gap: 8, marginTop: 8, flexWrap: "wrap" }}>
              {preview.dept_name && (
                <span style={{ fontSize: 11, background: "#DBEAFE", color: "#1D4ED8", padding: "2px 8px", borderRadius: 100, fontWeight: 600 }}>{preview.dept_name}</span>
              )}
              {preview.employee_code && (
                <span style={{ fontSize: 11, background: "#D1FAE5", color: "#065F46", padding: "2px 8px", borderRadius: 100, fontWeight: 600 }}>{preview.employee_code}</span>
              )}
            </div>
          </div>
        ) : null}

        <div style={{ marginBottom: 20 }}>
          <label style={{ fontSize: 13, fontWeight: 600, color: "#374151", display: "block", marginBottom: 7 }}>
            Enter your work email to continue
          </label>
          <input
            className="form-input"
            type="email"
            placeholder={emailPlaceholder}
            value={email}
            onChange={e => { setEmail(e.target.value); setError(""); }}
            onKeyDown={e => e.key === "Enter" && handle()}
            style={{ fontSize: 15 }}
          />
          {error ? (
            <div style={{ marginTop: 8, fontSize: 12, color: "#DC2626", display: "flex", alignItems: "flex-start", gap: 6, animation: "fadeIn .3s ease" }}>
              <span>⚠️</span><span>{error}</span>
            </div>
          ) : (
            <div style={{ marginTop: 7, fontSize: 11, color: "#94A3B8" }}>{domainHint}</div>
          )}
        </div>

        <button
          className="step-btn step-btn-primary"
          style={{ width: "100%", justifyContent: "center", fontSize: 15 }}
          onClick={handle}
          disabled={!email || loading}
        >
          {loading
            ? <><div style={{ width: 18, height: 18, border: "2.5px solid rgba(255,255,255,.3)", borderTopColor: "#fff", borderRadius: "50%", animation: "spin .8s linear infinite" }} /> Verifying…</>
            : <>Continue <span>→</span></>
          }
        </button>

        <div style={{ textAlign: "center", marginTop: 18, fontSize: 12, color: "#94A3B8" }}>
          Need help? Contact <span style={{ color: "#E8520A", fontWeight: 600 }}>admin@dolluzcorp.com</span>
        </div>
      </div>
    </div>
  );
};

/* ─── Screen: OTP ────────────────────────────────────────────────────── */
const OTPScreen = ({ email, otpEmail, devOtp, reviewId, onNext }) => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [errorMsg, setErrorMsg] = useState("");
  const [infoMsg, setInfoMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [resending, setResending] = useState(false);
  const [resendCooldown, setResendCooldown] = useState(0);
  const [countdown, setCountdown] = useState(600);
  const refs = [useRef(), useRef(), useRef(), useRef(), useRef(), useRef()];

  useEffect(() => {
    refs[0].current?.focus();
    const t = setInterval(() => setCountdown(c => c > 0 ? c - 1 : 0), 1000);
    return () => clearInterval(t);
  }, []); // eslint-disable-line

  // Resend cooldown — 30s between resend requests to avoid hammering email infra.
  useEffect(() => {
    if (resendCooldown <= 0) return;
    const t = setTimeout(() => setResendCooldown(c => c - 1), 1000);
    return () => clearTimeout(t);
  }, [resendCooldown]);

  const handleResend = async () => {
    if (resendCooldown > 0 || resending) return;
    setResending(true);
    setErrorMsg("");
    setInfoMsg("");
    try {
      const res = await apiFetch("/api/auth/stakeholder/request-otp", {
        method: "POST",
        body: JSON.stringify({ email, reviewId }),
      });
      const data = await res.json();
      if (!res.ok || !data.otpSent) {
        setErrorMsg(data.message || "Failed to resend OTP. Please try again.");
        return;
      }
      // Fresh OTP issued — clear inputs, restart the 10-min expiry, start
      // a 30s cooldown before the next resend.
      setOtp(["", "", "", "", "", ""]);
      setCountdown(600);
      setResendCooldown(30);
      setInfoMsg("A new code has been sent to your inbox.");
      setTimeout(() => refs[0].current?.focus(), 50);
    } catch (e) {
      setErrorMsg("Network error. Please try again.");
    } finally { setResending(false); }
  };

  // Fill boxes from position i using a string of digits
  const fillFrom = (startIdx, digits) => {
    const next = ["", "", "", "", "", ""];
    // Keep existing values for boxes before startIdx
    for (let b = 0; b < startIdx; b++) next[b] = otp[b];
    // Fill forward from startIdx with the digits
    for (let d = 0; d < digits.length && startIdx + d < 6; d++) {
      next[startIdx + d] = digits[d];
    }
    setOtp(next);
    setErrorMsg("");
    // Move focus to the box after the last filled digit, or the last box
    const lastFilled = Math.min(startIdx + digits.length, 5);
    setTimeout(() => refs[lastFilled].current?.focus(), 0);
  };

  const handleKey = (i, val) => {
    // Strip non-digits
    const digits = val.replace(/\D/g, "");
    if (!digits && val) return; // non-numeric input — reject
    if (!digits) {
      // Clearing the box
      const next = [...otp]; next[i] = ""; setOtp(next); setErrorMsg("");
      return;
    }
    // If pasted/autofilled more than one digit into one box — fill forward from position i
    if (digits.length > 1) {
      fillFrom(i, digits);
      return;
    }
    // Single digit — fill current box and advance focus
    const next = [...otp]; next[i] = digits; setOtp(next); setErrorMsg("");
    if (i < 5) refs[i + 1].current?.focus();
  };

  const handleBackspace = (i, e) => {
    if (e.key === "Backspace" && !otp[i] && i > 0) refs[i - 1].current?.focus();
  };

  // onPaste — works on any box: paste fills from that box's position
  const handlePaste = (i, e) => {
    e.preventDefault();
    const text = e.clipboardData?.getData("text") || "";
    const digits = text.replace(/\D/g, "").slice(0, 6); // numbers only, max 6
    if (!digits) return; // ignore if pasted text has no digits
    fillFrom(i, digits);
  };

  const verify = async () => {
    const code = otp.join(""); if (code.length < 6) return;
    setLoading(true);
    try {
      const res = await apiFetch("/api/auth/stakeholder/verify-otp", {
        method: "POST", body: JSON.stringify({ email, otp: code, reviewId }),
      });
      const data = await res.json();
      if (!res.ok) {
        setErrorMsg(data.message || "Incorrect OTP. Please try again.");
        setOtp(["", "", "", "", "", ""]);
        setTimeout(() => refs[0].current?.focus(), 50);
        return;
      }
      onNext(data.token, data.reviewIds);
    } catch (e) {
      setErrorMsg("Network error. Please try again.");
    } finally { setLoading(false); }
  };

  const fmt = s => `${String(Math.floor(s / 60)).padStart(2, "0")}:${String(s % 60).padStart(2, "0")}`;
  const filled = otp.filter(Boolean).length;
  const pct = (600 - countdown) / 600;

  return (
    <div className="slide-up" style={{ width: "100%", maxWidth: 420 }}>
      <div style={{ background: "#fff", borderRadius: 24, padding: "40px 36px", boxShadow: "0 32px 80px rgba(0,0,0,.3)" }}>
        <div style={{ textAlign: "center", marginBottom: 8 }}>
          <div style={{ fontFamily: "'Sora',sans-serif", fontWeight: 800, fontSize: 22, color: "#0D1B2A" }}>
            Dolluz Corp<span style={{ color: "#E8520A" }}>.</span>
          </div>
        </div>
        <div style={{ textAlign: "center", margin: "20px 0 24px" }}>
          <div style={{ width: 72, height: 72, borderRadius: 20, background: "linear-gradient(135deg,#FFF5F0,#FED7C3)", border: "2px solid #FED7C3", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 32 }}>📬</div>
          <div style={{ fontFamily: "'Sora',sans-serif", fontWeight: 700, fontSize: 20, color: "#0D1B2A", marginTop: 14 }}>Check your inbox</div>
          <div style={{ fontSize: 13, color: "#64748B", marginTop: 6, lineHeight: 1.5 }}>
            We sent a 6-digit code to<br />
            <span style={{ fontWeight: 700, color: "#E8520A" }}>{email}</span>
          </div>
        </div>
        <div style={{ textAlign: "center", marginBottom: 22 }}>
          <div style={{ position: "relative", display: "inline-block" }}>
            <svg width="60" height="60" viewBox="0 0 60 60" style={{ transform: "rotate(-90deg)" }}>
              <circle cx="30" cy="30" r="22" fill="none" stroke="#F1F5F9" strokeWidth="4" />
              <circle cx="30" cy="30" r="22" fill="none"
                stroke={countdown < 60 ? "#EF4444" : "#E8520A"} strokeWidth="4"
                strokeDasharray="138" strokeDashoffset={138 * pct}
                strokeLinecap="round" style={{ transition: "stroke-dashoffset .9s linear" }}
              />
            </svg>
            <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'JetBrains Mono',monospace", fontSize: 11, fontWeight: 600, color: countdown < 60 ? "#EF4444" : "#0D1B2A" }}>
              {fmt(countdown)}
            </div>
          </div>
          <div style={{ fontSize: 11, color: "#94A3B8", marginTop: 4 }}>code expires</div>
        </div>
        <div style={{ display: "flex", gap: 8, justifyContent: "center", marginBottom: 24 }}>
          {otp.map((v, i) => (
            <input key={i} ref={refs[i]}
              className={`otp-input ${v ? "filled" : ""} ${errorMsg ? "error" : ""}`}
              maxLength={1} value={v} type="text" inputMode="numeric"
              onChange={e => handleKey(i, e.target.value)}
              onKeyDown={e => handleBackspace(i, e)}
              onPaste={e => handlePaste(i, e)}
            />
          ))}
        </div>
        {errorMsg && (
          <div style={{ textAlign: "center", fontSize: 13, color: "#DC2626", marginBottom: 16, animation: "fadeIn .3s ease" }}>
            ⚠️ {errorMsg}
          </div>
        )}
        {infoMsg && !errorMsg && (
          <div style={{ textAlign: "center", fontSize: 13, color: "#047857", marginBottom: 16, animation: "fadeIn .3s ease" }}>
            ✓ {infoMsg}
          </div>
        )}
        <button className="step-btn step-btn-primary" style={{ width: "100%", justifyContent: "center" }}
          onClick={verify} disabled={filled < 6 || loading}>
          {loading
            ? <><div style={{ width: 18, height: 18, border: "2.5px solid rgba(255,255,255,.3)", borderTopColor: "#fff", borderRadius: "50%", animation: "spin .8s linear infinite" }} /> Verifying…</>
            : "Verify & Open Review"
          }
        </button>
        <div style={{ textAlign: "center", marginTop: 16, fontSize: 12, color: "#94A3B8" }}>
          Didn't receive it?{" "}
          <button
            type="button"
            onClick={handleResend}
            disabled={resending || resendCooldown > 0}
            style={{
              color: (resending || resendCooldown > 0) ? "#94A3B8" : "#E8520A",
              fontWeight: 600,
              cursor: (resending || resendCooldown > 0) ? "default" : "pointer",
              background: "none", border: "none", padding: 0, font: "inherit",
            }}>
            {resending ? "Resending…" : resendCooldown > 0 ? `Resend in ${resendCooldown}s` : "Resend code"}
          </button>
        </div>
      </div>
    </div>
  );
};

/* ─── Screen: Select Employee ────────────────────────────────────────── */
const SelectScreen = ({ reviews, submittedIds, onSelect }) => {
  const pending = reviews.filter(r => !submittedIds.includes(String(r.id)));
  const completed = reviews.filter(r => submittedIds.includes(String(r.id)));

  const statusColor = s => ({
    "Not Started": { bg: "#F1F5F9", color: "#64748B", label: "Not Started" },
    "Initiated": { bg: "#FFF7ED", color: "#C2410C", label: "Awaiting" },
    "In Progress": { bg: "#EFF6FF", color: "#1D4ED8", label: "In Progress" },
    "Submitted": { bg: "#F0FDF4", color: "#15803D", label: "Submitted" },
    "Approved": { bg: "#F0FDF4", color: "#15803D", label: "Approved" },
  }[s] || { bg: "#F1F5F9", color: "#64748B", label: s });

  return (
    <div className="slide-up" style={{ width: "100%", maxWidth: 520 }}>
      <div style={{ background: "#fff", borderRadius: 24, padding: "36px 32px", boxShadow: "0 32px 80px rgba(0,0,0,.3)" }}>
        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <div style={{ fontFamily: "'Sora',sans-serif", fontWeight: 800, fontSize: 22, color: "#0D1B2A" }}>
            Dolluz Corp<span style={{ color: "#E8520A" }}>.</span>
          </div>
          <div style={{ fontFamily: "'Sora',sans-serif", fontWeight: 700, fontSize: 18, color: "#0D1B2A", marginTop: 16 }}>
            Your pending reviews
          </div>
          <div style={{ fontSize: 13, color: "#64748B", marginTop: 6 }}>
            {pending.length} pending · {completed.length} completed
          </div>
          {/* Progress bar */}
          <div style={{ margin: "12px auto 0", maxWidth: 280 }}>
            <div className="progress-track">
              <div className="progress-fill" style={{ width: `${reviews.length ? (completed.length / reviews.length) * 100 : 0}%` }} />
            </div>
          </div>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {reviews.map(r => {
            const done = submittedIds.includes(String(r.id));
            const sc = statusColor(done ? "Submitted" : r.status);
            const initials = r.employee_name.split(" ").map(n => n[0]).join("").slice(0, 2).toUpperCase();
            return (
              <div key={r.id} style={{
                display: "flex", alignItems: "center", gap: 14,
                padding: "14px 16px", borderRadius: 14,
                border: `1.5px solid ${done ? "#BBF7D0" : "#E2E8F0"}`,
                background: done ? "#F0FDF4" : "#FAFAFA",
                transition: "all .2s",
              }}>
                {/* Avatar */}
                <div style={{
                  width: 44, height: 44, borderRadius: 12, flexShrink: 0,
                  background: done ? "linear-gradient(135deg,#86EFAC,#4ADE80)" : "linear-gradient(135deg,#E8520A,#FF8C5A)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontFamily: "'Sora',sans-serif", fontWeight: 800, fontSize: 16, color: "#fff",
                }}>
                  {done ? "✓" : initials}
                </div>
                {/* Info */}
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontWeight: 700, fontSize: 14, color: "#0D1B2A", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{r.employee_name}</div>
                  <div style={{ fontSize: 11, color: "#64748B", marginTop: 2 }}>
                    {[r.designation, r.client_name].filter(Boolean).join(" · ")}
                  </div>
                </div>
                {/* Status + action */}
                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 6, flexShrink: 0 }}>
                  <span style={{ fontSize: 10, fontWeight: 700, padding: "2px 8px", borderRadius: 100, background: sc.bg, color: sc.color }}>{sc.label}</span>
                  {!done && (
                    <button className="step-btn step-btn-primary"
                      style={{ padding: "7px 14px", fontSize: 12, borderRadius: 8 }}
                      onClick={() => onSelect(r.id)}>
                      Start →
                    </button>
                  )}
                </div>
              </div>
            );
          })}
        </div>

        {pending.length === 0 && (
          <div style={{ textAlign: "center", marginTop: 20, padding: "16px", background: "#F0FDF4", borderRadius: 12 }}>
            <div style={{ fontSize: 20, marginBottom: 6 }}>🎉</div>
            <div style={{ fontWeight: 700, color: "#15803D", fontSize: 14 }}>All reviews completed!</div>
            <div style={{ fontSize: 12, color: "#16A34A", marginTop: 4 }}>Thank you for completing all your performance reviews.</div>
          </div>
        )}
      </div>
    </div>
  );
};

/* ─── Screen: Review Form ────────────────────────────────────────────── */
const FormScreen = ({ onSubmit, onBack, onAlreadySubmitted, hasMultiple, sendCopy, setSendCopy, token, reviewId, reviewData }) => {
  const [ratings, setRatings] = useState({});
  const [prevGoals, setPrevGoals] = useState("");
  const [nextGoals, setNextGoals] = useState("");
  const [feedback, setFeedback] = useState("");
  const [activeSection, setActiveSection] = useState("Performance");
  const [tabOffset, setTabOffset] = useState(0); // index of first visible tab
  const TABS_PER_PAGE_CONST = 4; // keep in sync with TABS_PER_PAGE inside render
  const [submitError, setSubmitError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [savedIndicator, setSavedIndicator] = useState(false);

  const criteria = (reviewData && reviewData.criteria && reviewData.criteria.length)
    ? reviewData.criteria : CRITERIA;
  // Global sequential display number for each criterion (sorted by section then id)
  // Used in the badge so the user sees 1,2,3... instead of raw DB ids
  // Derive ordered sections from criteria (preserving API sort_order)
  const SECTIONS = [...new Set(criteria.map(cr => cr.section))];

  // Build global sequential numbers in correct display order:
  // sorted by section order (as they appear in SECTIONS) then by sort_order within each section
  const criterionDisplayNum = {};
  let _globalN = 1;
  SECTIONS.forEach(sec => {
    [...criteria.filter(c => c.section === sec)]
      .sort((a, b) => (a.sort_order ?? a.id) - (b.sort_order ?? b.id))
      .forEach(cr => { criterionDisplayNum[cr.id] = _globalN++; });
  });

  const hasLoaded = useRef(false);
  useEffect(() => {
    setRatings({}); setPrevGoals(""); setNextGoals(""); setFeedback("");
    const firstSection = criteria.length > 0 ? criteria[0].section : "Performance";
    setActiveSection(firstSection); setSubmitError("");
    setTabOffset(0);
    hasLoaded.current = false;

    // Start with DB-saved responses (from a previously submitted partial — empty if first time)
    let mergedRatings = {};
    if (reviewData && reviewData.responses && reviewData.responses.length) {
      reviewData.responses.forEach(r => { mergedRatings[r.criterion_id] = r.rating; });
    }
    let mergedPrev = (reviewData && reviewData.text && reviewData.text.prev_goals) || "";
    let mergedNext = (reviewData && reviewData.text && reviewData.text.next_goals) || "";
    let mergedFeedback = (reviewData && reviewData.text && reviewData.text.free_feedback) || "";

    let cancelled = false;

    const applyAndArm = (ratings, prev, next, fb) => {
      if (cancelled) return;
      setRatings(ratings);
      setPrevGoals(prev);
      setNextGoals(next);
      setFeedback(fb);
      // Mark loaded on the next tick so the save effect doesn't fire for the
      // initial state we just hydrated.
      setTimeout(() => { if (!cancelled) hasLoaded.current = true; }, 0);
    };

    // Overlay with server-side draft (keyed by review_id + logged-in email).
    // Falls back to whatever we already have if there's no draft / it errors.
    if (reviewId && token) {
      apiFetch(`/api/reviews/${reviewId}/draft`, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then(r => r.ok ? r.json() : null)
        .then(payload => {
          const d = payload && payload.data;
          if (d) {
            if (d.ratings && Object.keys(d.ratings).length > 0) mergedRatings = { ...mergedRatings, ...d.ratings };
            if (d.prev_goals) mergedPrev = d.prev_goals;
            if (d.next_goals) mergedNext = d.next_goals;
            if (d.feedback) mergedFeedback = d.feedback;
          }
          applyAndArm(mergedRatings, mergedPrev, mergedNext, mergedFeedback);
        })
        .catch(() => applyAndArm(mergedRatings, mergedPrev, mergedNext, mergedFeedback));
    } else {
      applyAndArm(mergedRatings, mergedPrev, mergedNext, mergedFeedback);
    }

    return () => { cancelled = true; };
  }, [reviewId, reviewData, token]);

  // Debounced save to server-side draft on every change — but only AFTER
  // the initial load has completed (otherwise the empty initial state
  // would overwrite the draft we're trying to read).
  useEffect(() => {
    if (!reviewId || !token) return;
    if (!hasLoaded.current) return;

    const t = setTimeout(async () => {
      try {
        const res = await apiFetch(`/api/reviews/${reviewId}/draft`, {
          method: "PUT",
          headers: { Authorization: `Bearer ${token}` },
          body: JSON.stringify({ ratings, prev_goals: prevGoals, next_goals: nextGoals, feedback }),
        });
        if (res.ok) {
          setSavedIndicator(true);
          setTimeout(() => setSavedIndicator(false), 2000);
        }
      } catch (e) { /* network blip — next change will retry */ }
    }, 600);
    return () => clearTimeout(t);
  }, [ratings, prevGoals, nextGoals, feedback, reviewId, token]);

  // Poll review status every 20s while the form is open. If someone else
  // (admin / another reviewer) submits this review while we're filling it,
  // we detect the terminal status and redirect to the "Already Submitted"
  // screen — without the user having to click submit and get rejected.
  useEffect(() => {
    if (!reviewId) return;
    let cancelled = false;
    const check = async () => {
      try {
        const res = await apiFetch(`/api/reviews/${reviewId}/preview`);
        if (!res.ok) return;
        const data = await res.json();
        if (cancelled || !data || !data.data) return;
        const st = data.data.status;
        if ((st === "Submitted" || st === "Approved" || st === "Closed") && onAlreadySubmitted) {
          onAlreadySubmitted(reviewId);
        }
      } catch (e) { /* network blip — try again next interval */ }
    };
    const t = setInterval(check, 20000);
    return () => { cancelled = true; clearInterval(t); };
  }, [reviewId, onAlreadySubmitted]);

  const totalRated = Object.keys(ratings).length;
  const progress = Math.round((totalRated / criteria.length) * 100);
  // Ensure active section tab is always visible when activeSection changes
  useEffect(() => {
    const idx = SECTIONS.indexOf(activeSection);
    if (idx < 0) return;
    if (idx < tabOffset || idx >= tabOffset + TABS_PER_PAGE_CONST) {
      setTabOffset(Math.floor(idx / TABS_PER_PAGE_CONST) * TABS_PER_PAGE_CONST);
    }
  }, [activeSection]); // eslint-disable-line

  const sectionCriteria = s => [...criteria.filter(c => c.section === s)].sort((a, b) => (a.sort_order ?? a.id) - (b.sort_order ?? b.id));
  const sectionProgress = s => {
    const c = sectionCriteria(s);
    const done = c.filter(cr => ratings[cr.id]).length;
    return Math.round((done / c.length) * 100);
  };
  const hasAnyInput = totalRated > 0 || prevGoals.trim().length > 0 || nextGoals.trim().length > 0 || feedback.trim().length > 0;

  const handleSubmit = async () => {
    setSubmitError(""); setSubmitting(true);
    try {
      const responses = Object.entries(ratings).map(([criterion_id, rating]) => ({
        criterion_id: parseInt(criterion_id), rating, comment: "",
      }));
      const res = await apiFetch(`/api/reviews/${reviewId}/submit`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: JSON.stringify({ responses, prev_goals: prevGoals, next_goals: nextGoals, free_feedback: feedback, send_copy: sendCopy }),
      });
      const data = await res.json();
      if (!res.ok) {
        // Race: another filler (admin or stakeholder) already submitted this
        // review while this form was open. Hand the user to the "Already
        // Submitted" screen instead of letting them retry against a terminal status.
        if (res.status === 409 && data.code === "REVIEW_ALREADY_SUBMITTED") {
          if (onAlreadySubmitted) onAlreadySubmitted(reviewId);
          return;
        }
        setSubmitError(data.message || "Submission failed. Please try again.");
        return;
      }
      // Server flushes the draft row on submit; no client-side cleanup needed.
      onSubmit(reviewId);
    } catch (e) {
      setSubmitError("Network error. Please try again.");
    } finally { setSubmitting(false); }
  };

  const ratingColor = v => ["", "#EF4444", "#F59E0B", "#3B82F6", "#10B981"][v] || "#E2E8F0";
  const emp = reviewData && reviewData.review ? reviewData.review : {};

  return (
    <div style={{ width: "100%", maxWidth: 760, paddingBottom: 40 }}>
      {/* Sticky header */}
      <div style={{
        background: "rgba(13,27,42,.92)", backdropFilter: "blur(16px)",
        borderRadius: 18, padding: "16px 24px", marginBottom: 20,
        boxShadow: "0 8px 32px rgba(0,0,0,.3)", position: "sticky", top: 16, zIndex: 10
      }} className="fade-in">
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            {hasMultiple && (
              <button onClick={onBack} style={{
                background: "rgba(255,255,255,.1)", border: "none", borderRadius: 8,
                color: "rgba(255,255,255,.7)", fontSize: 12, padding: "5px 10px",
                cursor: "pointer", fontFamily: "'DM Sans',sans-serif",
              }}>← All Reviews</button>
            )}
            <div style={{ fontFamily: "'Sora',sans-serif", fontWeight: 800, fontSize: 16, color: "#fff", letterSpacing: -.5 }}>
              Dolluz Corp<span style={{ color: "#E8520A" }}>.</span>
              <span style={{ fontWeight: 400, fontSize: 13, color: "rgba(255,255,255,.5)", marginLeft: 8 }}>Performance Review</span>
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            {savedIndicator && (
              <span style={{ fontSize: 12, color: "#10B981", fontWeight: 600, display: "flex", alignItems: "center", gap: 4, animation: "fadeIn .2s ease" }}>
                ✓ Saved
              </span>
            )}
            <span style={{ fontFamily: "'JetBrains Mono',monospace", fontSize: 12, color: "rgba(255,255,255,.5)", background: "rgba(255,255,255,.08)", padding: "4px 10px", borderRadius: 8 }}>
              {emp.cycle_name || "Active Cycle"}
            </span>
            <span style={{ fontSize: 13, fontWeight: 700, color: progress === 100 ? "#10B981" : "#E8520A" }}>{progress}%</span>
          </div>
        </div>
        <div className="progress-track"><div className="progress-fill" style={{ width: `${progress}%` }} /></div>
        <div style={{ display: "flex", justifyContent: "space-between", marginTop: 6, fontSize: 11, color: "rgba(255,255,255,.4)" }}>
          <span>{totalRated} of {criteria.length} criteria rated</span>
          <span>{criteria.length - totalRated} remaining</span>
        </div>
      </div>

      {/* Employee info card */}
      <div className="section-card fade-up" style={{ padding: "20px 24px", background: "linear-gradient(135deg,#0D1B2A,#1A3A5C)", border: "none" }}>
        {/* Row 1: Avatar + Name */}
        <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 16 }}>
          <div style={{ width: 52, height: 52, borderRadius: 16, background: "linear-gradient(135deg,#E8520A,#FF8C5A)", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'Sora',sans-serif", fontWeight: 800, fontSize: 20, color: "#fff", flexShrink: 0 }}>
            {(emp.employee_name || "?").split(" ").map(n => n[0]).join("").slice(0, 2).toUpperCase()}
          </div>
          <div>
            <div style={{ fontFamily: "'Sora',sans-serif", fontWeight: 700, fontSize: 18, color: "#fff" }}>{emp.employee_name || "—"}</div>
            <div style={{ fontSize: 12, color: "rgba(255,255,255,.55)", marginTop: 2 }}>{emp.designation}{emp.employee_code ? ` · ${emp.employee_code}` : ""}</div>
          </div>
        </div>
        {/* Row 2: Meta grid */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: "8px 16px", borderTop: "1px solid rgba(255,255,255,.1)", paddingTop: 14 }}>
          {[["Client", emp.client_name], ["Dept", emp.department], ["Quarter", emp.cycle_name], ["Reviewer", emp.stakeholder_name]].map(([label, value]) => (
            <div key={label}>
              <div style={{ fontSize: 10, color: "rgba(255,255,255,.38)", fontWeight: 700, textTransform: "uppercase", letterSpacing: 1, marginBottom: 4 }}>{label}</div>
              <div style={{ fontSize: 13, color: "rgba(255,255,255,.9)", fontWeight: 600, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{value || "—"}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Section tabs — paginated, 4 visible at a time */}
      {(() => {
        const TABS_PER_PAGE = 4;
        const visibleSecs = SECTIONS.slice(tabOffset, tabOffset + TABS_PER_PAGE);
        const canPrev = tabOffset > 0;
        const canNext = tabOffset + TABS_PER_PAGE < SECTIONS.length;
        const needsPager = SECTIONS.length > TABS_PER_PAGE;

        return (
          <div style={{ display: "flex", alignItems: "stretch", gap: 6, marginBottom: 16 }} className="fade-up">
            {/* Prev arrow */}
            {needsPager && (
              <button onClick={() => setTabOffset(o => Math.max(0, o - TABS_PER_PAGE))} disabled={!canPrev}
                style={{
                  width: 32, flexShrink: 0, borderRadius: 10, border: "1.5px solid #E2E8F0",
                  background: canPrev ? "#fff" : "#F8FAFC", cursor: canPrev ? "pointer" : "not-allowed",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontSize: 14, color: canPrev ? "#0D1B2A" : "#CBD5E1", transition: "all .15s",
                }}
                onMouseEnter={e => { if (canPrev) e.currentTarget.style.borderColor = "#E8520A"; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = "#E2E8F0"; }}>
                &#8249;
              </button>
            )}

            {/* Visible tabs */}
            {visibleSecs.map(s => {
              const pct = sectionProgress(s); const isActive = activeSection === s;
              return (
                <button key={s} onClick={() => setActiveSection(s)} style={{
                  flex: 1, padding: "10px 8px", borderRadius: 12, border: "2px solid",
                  borderColor: isActive ? "#E8520A" : "#E2E8F0",
                  background: isActive ? "#FFF5F0" : "#fff",
                  cursor: "pointer", transition: "all .2s", minWidth: 0,
                  display: "flex", flexDirection: "column", alignItems: "center", gap: 6
                }}>
                  <span style={{ fontSize: 12, fontWeight: 700, color: isActive ? "#E8520A" : "#64748B", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "100%" }}>{s}</span>
                  <div style={{ width: "100%", height: 3, background: "#F1F5F9", borderRadius: 100, overflow: "hidden" }}>
                    <div style={{ height: "100%", width: `${pct}%`, background: pct === 100 ? "#10B981" : "#E8520A", borderRadius: 100, transition: "width .4s" }} />
                  </div>
                  <span style={{ fontSize: 10, color: pct === 100 ? "#10B981" : "#94A3B8", fontWeight: 600 }}>{pct}%</span>
                </button>
              );
            })}

            {/* Placeholder divs to keep width consistent when fewer than 4 tabs */}
            {Array.from({ length: TABS_PER_PAGE - visibleSecs.length }).map((_, i) => (
              <div key={"ph" + i} style={{ flex: 1, minWidth: 0 }} />
            ))}

            {/* Next arrow */}
            {needsPager && (
              <button onClick={() => setTabOffset(o => Math.min(SECTIONS.length - TABS_PER_PAGE, o + TABS_PER_PAGE))} disabled={!canNext}
                style={{
                  width: 32, flexShrink: 0, borderRadius: 10, border: "1.5px solid #E2E8F0",
                  background: canNext ? "#fff" : "#F8FAFC", cursor: canNext ? "pointer" : "not-allowed",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontSize: 14, color: canNext ? "#0D1B2A" : "#CBD5E1", transition: "all .15s",
                }}
                onMouseEnter={e => { if (canNext) e.currentTarget.style.borderColor = "#E8520A"; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = "#E2E8F0"; }}>
                &#8250;
              </button>
            )}

            {/* Page dots indicator */}
            {needsPager && (
              <div style={{ display: "flex", alignItems: "center", gap: 4, marginLeft: 4, flexShrink: 0 }}>
                {Array.from({ length: Math.ceil(SECTIONS.length / TABS_PER_PAGE) }).map((_, pi) => (
                  <div key={pi} onClick={() => setTabOffset(pi * TABS_PER_PAGE)}
                    style={{
                      width: pi * TABS_PER_PAGE === tabOffset ? 14 : 6,
                      height: 6, borderRadius: 100, cursor: "pointer", transition: "all .2s",
                      background: pi * TABS_PER_PAGE === tabOffset ? "#E8520A" : "#CBD5E1",
                    }} />
                ))}
              </div>
            )}
          </div>
        );
      })()}

      {/* Criteria */}
      <div className="section-card fade-up">
        <div style={{ padding: "16px 22px", borderBottom: "1px solid #F1F5F9", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ fontFamily: "'Sora',sans-serif", fontWeight: 700, fontSize: 15, color: "#0D1B2A" }}>{activeSection}</div>
          <span style={{ fontSize: 12, color: "#94A3B8" }}>{sectionCriteria(activeSection).length} criteria</span>
        </div>
        <div style={{ padding: "4px 0" }}>
          {sectionCriteria(activeSection).map((c, ci) => {
            const selected = ratings[c.id];
            return (
              <div key={c.id} style={{
                padding: "16px 22px",
                borderBottom: ci < sectionCriteria(activeSection).length - 1 ? "1px solid #F8FAFC" : "none",
                background: selected ? `${ratingColor(selected)}08` : "#fff", transition: "background .2s"
              }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
                  <span style={{ width: 22, height: 22, borderRadius: 6, background: selected ? ratingColor(selected) : "#F1F5F9", color: selected ? "#fff" : "#94A3B8", fontSize: 11, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, transition: "all .2s" }}>
                    {selected ? "✓" : (criterionDisplayNum[c.id] ?? c.id)}
                  </span>
                  <span style={{ fontSize: 14, fontWeight: 600, color: "#1E293B" }}>{c.label}</span>
                  {selected && <span style={{ marginLeft: "auto", fontSize: 11, fontWeight: 700, color: ratingColor(selected) }}>{RATINGS[selected - 1].label}</span>}
                </div>
                <div style={{ display: "flex", gap: 8 }}>
                  {RATINGS.map(r => (
                    <button key={r.value} className={`rating-btn ${selected === r.value ? `selected-${r.value}` : ""}`}
                      onClick={() => setRatings(prev => ({ ...prev, [c.id]: r.value }))}>
                      <span style={{ fontSize: 16 }}>{r.emoji}</span>
                      <span>{r.label}</span>
                    </button>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Section nav + Save & Exit — shown above Goals so user doesn't need to scroll up */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", margin: "16px 0 8px" }}>
        {(() => {
          const idx = SECTIONS.indexOf(activeSection);
          const hasPrev = idx > 0;
          const hasNext = idx < SECTIONS.length - 1;
          const goTo = s => { setActiveSection(s); window.scrollTo({ top: 0, behavior: "smooth" }); };
          return (
            <div style={{ display: "flex", gap: 8 }}>
              <button disabled={!hasPrev} onClick={() => hasPrev && goTo(SECTIONS[idx - 1])}
                style={{
                  display: "flex", alignItems: "center", gap: 5, padding: "9px 16px",
                  border: "1.5px solid #E2E8F0", borderRadius: 10, fontSize: 13, fontWeight: 600,
                  background: hasPrev ? "#fff" : "#F8FAFC",
                  color: hasPrev ? "#374151" : "#CBD5E1",
                  cursor: hasPrev ? "pointer" : "not-allowed",
                }}
                onMouseEnter={e => { if (hasPrev) e.currentTarget.style.borderColor = "#E8520A"; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = "#E2E8F0"; }}>
                &#8592; Previous
              </button>
              <button disabled={!hasNext} onClick={() => hasNext && goTo(SECTIONS[idx + 1])}
                style={{
                  display: "flex", alignItems: "center", gap: 5, padding: "9px 16px",
                  border: "1.5px solid #E8520A", borderRadius: 10, fontSize: 13, fontWeight: 600,
                  background: hasNext ? "#FFF5F0" : "#F8FAFC",
                  color: hasNext ? "#E8520A" : "#CBD5E1",
                  cursor: hasNext ? "pointer" : "not-allowed",
                }}
                onMouseEnter={e => { if (hasNext) { e.currentTarget.style.background = "#E8520A"; e.currentTarget.style.color = "#fff"; } }}
                onMouseLeave={e => { if (hasNext) { e.currentTarget.style.background = "#FFF5F0"; e.currentTarget.style.color = "#E8520A"; } }}>
                Next &#8594;
              </button>
            </div>
          );
        })()}
        <button className="step-btn"
          style={{ padding: "10px 18px", border: "2px solid #E2E8F0", background: "#fff", color: "#374151", fontWeight: 600, fontSize: 13, borderRadius: 12, cursor: "pointer", display: "flex", alignItems: "center", gap: 6 }}
          onClick={() => { onBack ? onBack() : window.history.back(); }}>
          💾 Save & Exit
        </button>
      </div>

      {/* Goals & Feedback */}
      {totalRated >= 5 && (
        <div className="fade-up">
          {[
            ["Goals — Previous Period", "How well were the goals set last period achieved?", prevGoals, setPrevGoals, "Describe goals from the previous period and achievement level…"],
            ["Goals — Next Period", "What goals are you setting for this associate next period?", nextGoals, setNextGoals, "Set clear, measurable goals for the next review period…"],
          ].map(([title, sub, val, setter, placeholder]) => (
            <div key={title} className="section-card">
              <div style={{ padding: "16px 22px", borderBottom: "1px solid #F1F5F9" }}>
                <div style={{ fontFamily: "'Sora',sans-serif", fontWeight: 700, fontSize: 15, color: "#0D1B2A" }}>{title}</div>
                <div style={{ fontSize: 12, color: "#94A3B8", marginTop: 2 }}>{sub}</div>
              </div>
              <div style={{ padding: "18px 22px" }}>
                <textarea className="form-input" rows={3} placeholder={placeholder}
                  value={val} onChange={e => setter(e.target.value)}
                  style={{ resize: "vertical", lineHeight: 1.6 }} />
                <div style={{ textAlign: "right", fontSize: 11, color: "#94A3B8", marginTop: 5 }}>{val.length} characters</div>
              </div>
            </div>
          ))}
          <div className="section-card">
            <div style={{ padding: "16px 22px", borderBottom: "1px solid #F1F5F9" }}>
              <div style={{ fontFamily: "'Sora',sans-serif", fontWeight: 700, fontSize: 15, color: "#0D1B2A" }}>Overall Feedback</div>
              <div style={{ fontSize: 12, color: "#94A3B8", marginTop: 2 }}>Optional — any additional comments or areas of improvement</div>
            </div>
            <div style={{ padding: "18px 22px" }}>
              <textarea className="form-input" rows={3} placeholder="Share any additional observations…"
                value={feedback} onChange={e => setFeedback(e.target.value)} style={{ resize: "vertical", lineHeight: 1.6 }} />
            </div>
          </div>
        </div>
      )}

      {/* Submit zone */}
      {totalRated >= 5 && (
        <div className="section-card fade-up" style={{ padding: "24px 26px" }}>
          <label className="copy-checkbox" style={{ marginBottom: 24 }}>
            <input type="checkbox" checked={sendCopy} onChange={e => setSendCopy(e.target.checked)} />
            <div>
              <div style={{ fontSize: 14, fontWeight: 600, color: "#92400E" }}>📧 Send a copy of this response to my email</div>
              <div style={{ fontSize: 12, color: "#B45309", marginTop: 3, lineHeight: 1.5 }}>A PDF copy of your completed review will be sent to your authenticated email. A copy will also be sent to the primary stakeholder (if different from you).</div>
            </div>
          </label>
          <div style={{ background: "#F8FAFC", borderRadius: 12, padding: "14px 16px", marginBottom: 20 }}>
            <div style={{ fontSize: 13, fontWeight: 600, color: "#374151", marginBottom: 10 }}>Review Completeness</div>
            {[
              ["Performance Criteria", `${totalRated}/${criteria.length} rated`, totalRated === criteria.length],
              ["Previous Period Goals", prevGoals.trim().length > 10 ? "Completed" : "Required", prevGoals.trim().length > 10],
              ["Next Period Goals", nextGoals.trim().length > 10 ? "Completed" : "Required", nextGoals.trim().length > 10],
            ].map(([l, v, done]) => (
              <div key={l} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
                <span style={{ fontSize: 13, color: "#64748B" }}>{l}</span>
                <span style={{ fontSize: 12, fontWeight: 700, color: done ? "#10B981" : "#EF4444" }}>{done ? "✓" : "○"} {v}</span>
              </div>
            ))}
          </div>
          {submitError && (
            <div style={{ marginBottom: 14, padding: "10px 14px", background: "#FEF2F2", border: "1px solid #FECACA", borderRadius: 10, fontSize: 13, color: "#DC2626" }}>
              ⚠️ {submitError}
            </div>
          )}
          <div style={{ display: "flex", gap: 12 }}>
            <button className="step-btn"
              style={{ flex: "0 0 auto", padding: "14px 20px", border: "2px solid #E2E8F0", background: "#fff", color: "#374151", fontWeight: 600, fontSize: 14, borderRadius: 12, cursor: "pointer", display: "flex", alignItems: "center", gap: 6 }}
              onClick={() => { onBack ? onBack() : window.history.back(); }}>
              💾 Save & Exit
            </button>
            <button className="step-btn step-btn-primary"
              style={{ flex: 1, justifyContent: "center", fontSize: 15, padding: "14px" }}
              onClick={handleSubmit}
              disabled={submitting || totalRated < criteria.length || prevGoals.trim().length <= 10 || nextGoals.trim().length <= 10}>
              {submitting
                ? <><div style={{ width: 18, height: 18, border: "2.5px solid rgba(255,255,255,.3)", borderTopColor: "#fff", borderRadius: "50%", animation: "spin .8s linear infinite" }} /> Submitting…</>
                : totalRated < criteria.length
                  ? `Rate ${criteria.length - totalRated} more criteria to submit`
                  : (prevGoals.trim().length <= 10 || nextGoals.trim().length <= 10)
                    ? "Please complete Goals fields to submit"
                    : hasMultiple ? "Submit & Back to Reviews ✓" : "Submit Review ✓"
              }
            </button>
          </div>
          <div style={{ textAlign: "center", marginTop: 14, fontSize: 12, color: "#94A3B8", lineHeight: 1.5 }}>
            Once submitted, this review link will expire permanently.<br />
            For amendments, contact <a href="mailto:admin@dolluzcorp.com" style={{ color: "#E8520A", fontWeight: 600 }}>admin@dolluzcorp.com</a>
          </div>
        </div>
      )}
    </div>
  );
};

/* ─── Screen: Submitted ──────────────────────────────────────────────── */
const SubmittedScreen = ({ sendCopy, employeeName, cycleName, criteriaCount, submittedAt, alreadySubmitted }) => (
  <div className="pop" style={{ width: "100%", maxWidth: 420 }}>
    <div style={{ background: "#fff", borderRadius: 24, padding: "48px 36px", boxShadow: "0 32px 80px rgba(0,0,0,.3)", textAlign: "center" }}>
      <div style={{ width: 80, height: 80, borderRadius: "50%", background: "linear-gradient(135deg,#D1FAE5,#A7F3D0)", border: "3px solid #10B981", display: "inline-flex", alignItems: "center", justifyContent: "center", marginBottom: 24 }}>
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
          <path d="M7 18L14 25L29 10" stroke="#10B981" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round"
            strokeDasharray="50" strokeDashoffset="0" style={{ animation: "checkDraw .6s ease .2s both" }} />
        </svg>
      </div>
      <div style={{ fontFamily: "'Sora',sans-serif", fontWeight: 800, fontSize: 22, color: "#0D1B2A", marginBottom: 8 }}>
        {alreadySubmitted ? "Already Submitted" : "Review Submitted!"}
      </div>
      <div style={{ fontSize: 14, color: "#64748B", lineHeight: 1.6, marginBottom: 24 }}>
        {alreadySubmitted
          ? <>Your review for <strong>{employeeName || "this employee"}</strong>{cycleName ? ` (${cycleName})` : ""} has already been submitted.<br />No further action is needed.</>
          : <>Thank you for completing the performance review for{" "}<strong>{employeeName || "this employee"}</strong>{cycleName ? ` (${cycleName})` : ""}.<br />Your response has been received by the Dolluz Corp team.</>
        }
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 28 }}>
        {[
          ["📋", `${criteriaCount || 17} criteria rated`, !alreadySubmitted],
          ["📅", `Submitted: ${submittedAt || new Date().toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}`, !alreadySubmitted && !!submittedAt],
          ["🔒", "This review link has expired", true],
          ["📧", "PDF copy sent to your email", !alreadySubmitted && sendCopy],
        ].filter(([, , show]) => show).map(([icon, text]) => (
          <div key={text} style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 14px", background: "#F8FAFC", borderRadius: 10, fontSize: 13, color: "#475569" }}>
            <span>{icon}</span><span>{text}</span>
          </div>
        ))}
      </div>
      <div style={{ fontSize: 12, color: "#94A3B8", lineHeight: 1.6 }}>
        For any amendments or queries, please contact<br />
        <span style={{ color: "#E8520A", fontWeight: 600 }}>admin@dolluzcorp.com</span>
      </div>
      <div style={{ marginTop: 28, paddingTop: 20, borderTop: "1px solid #F1F5F9" }}>
        <div style={{ fontFamily: "'Sora',sans-serif", fontWeight: 800, fontSize: 16, color: "#0D1B2A" }}>
          Dolluz Corp<span style={{ color: "#E8520A" }}>.</span>
        </div>
        <div style={{ fontSize: 10, color: "#94A3B8", letterSpacing: 1.5, textTransform: "uppercase", marginTop: 2 }}>Employee Performance Review</div>
      </div>
    </div>
  </div>
);

/* ─── Main App ───────────────────────────────────────────────────────── */
export default function App() {
  const [step, setStep] = useState("email"); // email | otp | select | form | submitted
  const [email, setEmail] = useState("");
  const [devOtp, setDevOtp] = useState(null);
  const [token, setToken] = useState(null);
  const [allReviews, setAllReviews] = useState([]);    // full list from /api/reviews/my
  const [reviewId, setReviewId] = useState(null);    // currently open review
  const [reviewData, setReviewData] = useState(null);  // form data for current review
  const [submittedIds, setSubmittedIds] = useState([]); // track which were submitted this session
  const [preview, setPreview] = useState(null);    // from public /preview endpoint
  const [previewLoading, setPreviewLoading] = useState(false);
  const [sendCopy, setSendCopy] = useState(false);
  const [submittedAt, setSubmittedAt] = useState(null);
  const [otpEmail, setOtpEmail] = useState(null); // masked stakeholder email (where OTP was sent)

  // Read ?r= param from URL
  const urlReviewId = (() => {
    try { return new URLSearchParams(window.location.search).get("r"); } catch { return null; }
  })();

  // On mount: if ?r= param, fetch public preview for dynamic employee banner.
  // If the review is already Submitted or Approved, show SubmittedScreen immediately
  // so the stakeholder doesn't see the email-entry step again on reload.
  useEffect(() => {
    if (!urlReviewId) return;
    setPreviewLoading(true);
    apiFetch(`/api/reviews/${urlReviewId}/preview`)
      .then(r => r.json())
      .then(data => {
        if (data.success) {
          setPreview(data.data);
          const st = data.data.status;
          if (st === "Submitted" || st === "Approved") {
            setStep("submitted_already");
          }
        }
      })
      .catch(() => { })
      .finally(() => setPreviewLoading(false));
  }, [urlReviewId]);

  // After OTP verify: respect the URL's specific review id so each emailed
  // link only opens the one employee it was sent for. The token still grants
  // access to every review this stakeholder owns (multi-employee CC stays
  // possible from /review without ?r=), but a direct link must never expose
  // the other employees on the select screen.
  const handleOtpSuccess = async (tok, reviewIds) => {
    setToken(tok);

    // Direct-link flow: ?r=<review_id> → load only that review.
    // The token still has to cover this review id, otherwise the form
    // endpoint will 403 and the user will get a clean error.
    if (urlReviewId) {
      if (Array.isArray(reviewIds) && reviewIds.length > 0 && !reviewIds.includes(urlReviewId)) {
        // Stakeholder is logged in but the URL points to a review they
        // don't own — surface a clear error instead of silently dumping
        // them on a list of someone else's employees.
        setStep("error");
        return;
      }
      await loadForm(tok, urlReviewId);
      return;
    }

    // Hub flow (no ?r= in the URL): load every review the stakeholder owns
    // so they can pick one. Used when admin shares the bare /review URL.
    try {
      const res = await apiFetch("/api/reviews/my", { headers: { Authorization: `Bearer ${tok}` } });
      const data = await res.json();
      if (res.ok && data.success) {
        setAllReviews(data.data);
        if (data.data.length === 1) {
          await loadForm(tok, data.data[0].id);
          return;
        }
        setStep("select");
      }
    } catch (e) {
      if (reviewIds.length === 1) {
        await loadForm(tok, reviewIds[0]);
      } else {
        setStep("select");
      }
    }
  };

  // Load form data for a specific review
  const loadForm = async (tok, rid) => {
    setReviewId(rid);
    setReviewData(null);
    try {
      const res = await apiFetch(`/api/reviews/${rid}/form`, { headers: { Authorization: `Bearer ${tok || token}` } });
      const data = await res.json();
      if (res.ok && data.success) setReviewData(data.data);
    } catch (e) { /* form loads with fallback */ }
    setStep("form");
  };

  // When stakeholder selects an employee from the list
  const handleSelectEmployee = (rid) => {
    loadForm(token, rid);
  };

  // When a review is submitted
  const handleSubmitSuccess = (submittedReviewId) => {
    const newSubmitted = [...submittedIds, String(submittedReviewId)];
    setSubmittedIds(newSubmitted);
    setSubmittedAt(new Date().toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }));

    const pending = allReviews.filter(r => !newSubmitted.includes(String(r.id)));
    if (pending.length === 0) {
      // All done
      setStep("submitted");
    } else if (allReviews.length > 1) {
      // More reviews pending — go back to select list
      setStep("select");
    } else {
      setStep("submitted");
    }
  };

  const steps = { email: 0, otp: 1, select: 2, form: 2, submitted: 3, submitted_already: -1 };
  const currentStep = steps[step] ?? 0;
  const hideProgressBar = step === "submitted_already" || step === "submitted";
  const hasMultiple = allReviews.length > 1;
  const criteriaCount = reviewData && reviewData.criteria ? reviewData.criteria.length : 17;
  const emp = reviewData && reviewData.review ? reviewData.review : {};

  return (
    <>
      <FontLink />
      <div style={{
        minHeight: "100vh", display: "flex", flexDirection: "column",
        alignItems: "center", justifyContent: "center",
        padding: step === "form" ? "20px 16px" : "24px 16px",
        position: "relative", fontFamily: "'DM Sans',sans-serif"
      }}>
        <Bg />

        {/* Step indicator — hidden when review already submitted */}
        {!hideProgressBar && (
          <div className="fade-in" style={{ position: "relative", zIndex: 1, display: "flex", alignItems: "center", gap: 8, marginBottom: 24 }}>
            {["Verify Email", "Enter OTP", "Complete Review"].map((s, i) => (
              <div key={i} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                  <div style={{
                    width: 24, height: 24, borderRadius: "50%",
                    background: i < currentStep ? "#10B981" : i === currentStep ? "#E8520A" : "rgba(255,255,255,.15)",
                    color: "#fff", fontSize: 11, fontWeight: 700,
                    display: "flex", alignItems: "center", justifyContent: "center", transition: "all .3s"
                  }}>{i < currentStep ? "✓" : i + 1}</div>
                  <span style={{ fontSize: 12, color: i <= currentStep ? "rgba(255,255,255,.9)" : "rgba(255,255,255,.35)", fontWeight: i === currentStep ? 600 : 400 }}>{s}</span>
                </div>
                {i < 2 && <div style={{ width: 28, height: 1, background: i < currentStep ? "#10B981" : "rgba(255,255,255,.15)", transition: "background .3s" }} />}
              </div>
            ))}
          </div>
        )}

        {/* Content */}
        <div style={{ position: "relative", zIndex: 1, width: "100%", display: "flex", justifyContent: "center" }}>
          {step === "email" && !urlReviewId && (
            <div className="slide-up" style={{ width: "100%", maxWidth: 440 }}>
              <div style={{ background: "#fff", borderRadius: 24, padding: "40px 36px", boxShadow: "0 32px 80px rgba(0,0,0,.3)", textAlign: "center" }}>
                <div style={{ width: 64, height: 64, borderRadius: 16, background: "#FEF2F2", border: "2px solid #FECACA", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 28, marginBottom: 16 }}>⚠️</div>
                <div style={{ fontFamily: "'Sora',sans-serif", fontWeight: 700, fontSize: 20, color: "#0D1B2A", marginBottom: 12 }}>Invalid Review Link</div>
                <div style={{ fontSize: 14, color: "#64748B", lineHeight: 1.6 }}>
                  This page requires a valid review link. Please use the link provided in your email invitation.
                </div>
                <div style={{ marginTop: 20, fontSize: 12, color: "#94A3B8" }}>
                  Need help? Contact <span style={{ color: "#E8520A", fontWeight: 600 }}>admin@dolluzcorp.com</span>
                </div>
              </div>
            </div>
          )}
          {step === "email" && urlReviewId && (
            <EmailScreen
              preview={preview}
              previewLoading={previewLoading}
              reviewId={urlReviewId}
              onNext={(e, dOtp, otpMail) => { setEmail(e); setDevOtp(dOtp); setOtpEmail(otpMail); setStep("otp"); }}
            />
          )}
          {step === "otp" && (
            <OTPScreen email={email} otpEmail={otpEmail} devOtp={devOtp} reviewId={urlReviewId} onNext={handleOtpSuccess} />
          )}
          {step === "select" && (
            <SelectScreen
              reviews={allReviews}
              submittedIds={submittedIds}
              onSelect={handleSelectEmployee}
            />
          )}
          {step === "form" && (
            <FormScreen
              sendCopy={sendCopy} setSendCopy={setSendCopy}
              token={token} reviewId={reviewId} reviewData={reviewData}
              hasMultiple={hasMultiple}
              onBack={() => setStep("select")}
              onSubmit={handleSubmitSuccess}
              onAlreadySubmitted={() => setStep("submitted_already")}
            />
          )}
          {step === "submitted" && (
            <SubmittedScreen
              sendCopy={sendCopy}
              employeeName={emp.employee_name}
              cycleName={emp.cycle_name}
              criteriaCount={criteriaCount}
              submittedAt={submittedAt}
            />
          )}
          {step === "submitted_already" && (
            <SubmittedScreen
              sendCopy={false}
              employeeName={preview?.employee_name}
              cycleName={preview?.cycle_name}
              criteriaCount={null}
              submittedAt={null}
              alreadySubmitted={true}
            />
          )}
        </div>

        {step !== "submitted" && (
          <div style={{ position: "relative", zIndex: 1, marginTop: 20, fontSize: 11, color: "rgba(255,255,255,.3)", textAlign: "center" }}>
            Secured by Dolluz Corp · EPR Portal · {new Date().getFullYear()} · Confidential
          </div>
        )}
      </div>
    </>
  );
}